import React from 'react';

/* This page is used for testing new features. It is not meant to be used in production. */

const TestPage = () => {
  return (
    <div>
      Test Page
    </div>
  );
};

export default TestPage;